import MainContainer from 'components/layout/MainContainer/MainContainer'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import COLORS from 'lib/colors'

export default function DashboardZeroState() {
  return (
    <MainContainer>
      <Paper sx={{ p: '25px 30px' }}>
        <Typography variant='h2' sx={{ mb: 3 }}>
          Dashboard
        </Typography>
        <Typography variant='body2' align='center' color={COLORS.slateGray}>
          No data available. Contact your organization administrator to request access.
        </Typography>
      </Paper>
    </MainContainer>
  )
}
